import useContacts from "./useContacts";


const useGroundStationData = () => {
    const { all_ground_stations, set_all_ground_stations } = useContacts();
    return { all_ground_stations, set_all_ground_stations }
}

export default useGroundStationData
